/**
 * Keeps the active text color when pressing Enter, similar to Microsoft Word.
 * CKEditor 4 drops inline color on new paragraphs by default.
 */
export function setupCkeditorPersistTextColor(editor: any): void {
  const CK = (window as any).CKEDITOR;
  if (!CK || !editor) {
    return;
  }

  let pendingTextColor: string | null = null;

  function normalizeColor(color: string): string {
    if (color.indexOf("#") === 0) {
      return color;
    }
    if (color.indexOf("rgb") === 0 && CK.tools.convertRgbToHex) {
      return CK.tools.convertRgbToHex(color);
    }
    return color.indexOf("#") === 0 ? color : "#" + color.replace(/^#/, "");
  }

  function getColorFromPath(path: any): string | null {
    for (let i = 0; i < path.elements.length; i++) {
      const color = path.elements[i].getStyle("color");
      if (color) {
        return color;
      }
    }
    return null;
  }

  function getElementPath(): any {
    const selection = editor.getSelection();
    if (!selection) {
      return null;
    }
    return new CK.dom.elementPath(selection.getStartElement(), editor.editable());
  }

  function findLastColorInElement(element: any): string | null {
    const spans = element.find("span");
    for (let i = spans.count() - 1; i >= 0; i--) {
      const color = spans.getItem(i).getStyle("color");
      if (color) {
        return color;
      }
    }
    return element.getStyle("color") || null;
  }

  function applyTextColorStyle(color: string): void {
    const style = new CK.style(editor.config.colorButton_foreStyle, {
      color: normalizeColor(color),
    });
    style.type = CK.STYLE_INLINE;
    editor.applyStyle(style);
  }

  editor.on("afterCommandExec", function(event: any) {
    if (event.data.name === "textColor") {
      const commandData = event.data.commandData;
      const newStyle = commandData && commandData.newStyle;
      if (newStyle) {
        const styles = newStyle.getDefinition().styles;
        pendingTextColor = styles && styles.color ? styles.color : null;
      } else {
        pendingTextColor = null;
      }
      return;
    }

    if (event.data.name !== "enter") {
      return;
    }

    setTimeout(function() {
      const path = getElementPath();
      if (!path) {
        return;
      }

      const activeColor = getColorFromPath(path);
      if (activeColor) {
        return;
      }

      let colorToApply = pendingTextColor;
      if (!colorToApply && path.block) {
        const previousBlock = path.block.getPrevious();
        if (previousBlock) {
          colorToApply = findLastColorInElement(previousBlock);
        }
      }

      if (!colorToApply) {
        return;
      }

      pendingTextColor = colorToApply;
      applyTextColorStyle(colorToApply);
    }, 0);
  });
}
